export default __webpack_public_path__ + "static/media/aws-lambda.b86fa28f.png";